import { useRef } from 'react'
import createActions from './createActions'

export default function useForm() {
  const form = useRef(createActions())

  return [form.current]
}
